<template>
  <DefaultLayout>
    <OrchestratorChat />
  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import OrchestratorChat from '../components/orchestrator/OrchestratorChat.vue';
</script>
